import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import "@/index.css";
import App from "@/App";

// === Observabilidad (Glitchtip/Sentry) - Solo en producción ===
if (process.env.REACT_APP_SENTRY_DSN) {
  const scrub = (str) => {
    if (typeof str !== "string") return str;
    return str
      .replace(/\b[XYZ]?\d{7,8}[A-Z]\b/g, "[DNI]")
      .replace(/\b[A-HJNP-SUVW]\d{7}[0-9A-J]\b/g, "[CIF]")
      .replace(/\b[6-9]\d{8}\b/g, "[TEL]")
      .replace(/\b[A-Z]{2}\d{2}\s?(\d{4}\s?){5,6}\b/g, "[IBAN]")
      .replace(/\b([a-zA-Z0-9._%+-]{1,3})[a-zA-Z0-9._%+-]*@([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})\b/g, "$1***@$2");
  };
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_SENTRY_ENV || "production",
    release: process.env.REACT_APP_SENTRY_RELEASE || "lexduo-frontend@unknown",
    sendDefaultPii: false,
    tracesSampleRate: 0.0,
    enabled: process.env.NODE_ENV === "production",
    ignoreErrors: [
      "ResizeObserver loop limit exceeded",
      "Non-Error promise rejection captured",
      "Network request failed",
    ],
    beforeSend(event) {
      try {
        if (event.exception?.values) {
          event.exception.values.forEach((v) => {
            if (v.value) v.value = scrub(v.value);
          });
        }
        if (event.request?.url) event.request.url = scrub(event.request.url);
        if (event.user) event.user = event.user.id ? { id: event.user.id } : {};
        if (event.breadcrumbs) {
          event.breadcrumbs.forEach((bc) => {
            if (bc.message) bc.message = scrub(bc.message);
            if (bc.data?.url) bc.data.url = scrub(bc.data.url);
          });
        }
      } catch (e) { /* ignore scrubber failures */ }
      return event;
    },
  });
}

function ErrorFallback({ resetError }) {
  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, sans-serif",
      padding: "40px",
      textAlign: "center",
      background: "#fafafa",
    }}>
      <div style={{ fontSize: "48px", marginBottom: "20px" }}>⚠️</div>
      <h1 style={{ fontSize: "24px", marginBottom: "12px", color: "#222" }}>
        Se ha producido un error inesperado
      </h1>
      <p style={{ color: "#666", maxWidth: "500px", marginBottom: "24px" }}>
        El equipo técnico ha sido notificado automáticamente.
        Puedes intentar recargar la página o volver más tarde.
      </p>
      <div style={{ display: "flex", gap: "12px" }}>
        <button
          onClick={resetError}
          style={{
            padding: "10px 24px",
            border: "none",
            background: "#2563eb",
            color: "white",
            borderRadius: "6px",
            cursor: "pointer",
            fontSize: "14px",
            fontWeight: 500,
          }}
        >
          Reintentar
        </button>
        <button
          onClick={() => window.location.href = "/"}
          style={{
            padding: "10px 24px",
            border: "1px solid #ddd",
            background: "white",
            color: "#333",
            borderRadius: "6px",
            cursor: "pointer",
            fontSize: "14px",
          }}
        >
          Ir al inicio
        </button>
      </div>
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={ErrorFallback} showDialog={false}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
